
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/szolgaltatasok/szemelyes-tanacsadas",
      function () {
        return require("private-next-pages/szolgaltatasok/szemelyes-tanacsadas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/szolgaltatasok/szemelyes-tanacsadas"])
      });
    }
  